import { render, staticRenderFns } from "./MobilePreview.vue?vue&type=template&id=0a45ca43&scoped=true"
import script from "./MobilePreview.vue?vue&type=script&lang=js"
export * from "./MobilePreview.vue?vue&type=script&lang=js"
import style0 from "./MobilePreview.vue?vue&type=style&index=0&id=0a45ca43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a45ca43",
  null
  
)

export default component.exports